export const LANGUAGES = [
  { code: "en", name: "English", flag: "🇬🇧", nativeName: "English" },
  { code: "af", name: "Afrikaans", flag: "🇿🇦", nativeName: "Afrikaans" },
  { code: "zu", name: "Zulu", flag: "🇿🇦", nativeName: "isiZulu" },
  { code: "xh", name: "Xhosa", flag: "🇿🇦", nativeName: "isiXhosa" },
  { code: "st", name: "Sotho", flag: "🇿🇦", nativeName: "Sesotho" },
  { code: "es", name: "Spanish", flag: "🇪🇸", nativeName: "Español" },
  { code: "fr", name: "French", flag: "🇫🇷", nativeName: "Français" },
  { code: "pt", name: "Portuguese", flag: "🇧🇷", nativeName: "Português" },
  { code: "ar", name: "Arabic", flag: "🇸🇦", nativeName: "العربية", rtl: true },
  { code: "zh", name: "Mandarin", flag: "🇨🇳", nativeName: "中文" },
  { code: "hi", name: "Hindi", flag: "🇮🇳", nativeName: "हिन्दी" },
  { code: "de", name: "German", flag: "🇩🇪", nativeName: "Deutsch" },
  { code: "nl", name: "Dutch", flag: "🇳🇱", nativeName: "Nederlands" },
  { code: "sw", name: "Swahili", flag: "🇰🇪", nativeName: "Kiswahili" },
  { code: "ha", name: "Hausa", flag: "🇳🇬", nativeName: "Hausa" },
  { code: "yo", name: "Yoruba", flag: "🇳🇬", nativeName: "Yorùbá" },
];

export const LANGUAGE_NAMES = {
  en: "English", af: "Afrikaans", zu: "isiZulu", xh: "isiXhosa",
  st: "Sesotho", es: "Español", fr: "Français", pt: "Português",
  ar: "العربية", zh: "中文", hi: "हिन्दी", de: "Deutsch",
  nl: "Nederlands", sw: "Kiswahili", ha: "Hausa", yo: "Yorùbá",
};
